// extracted by mini-css-extract-plugin
export default {"wrap":"yrFOV","option":"o912r","input":"bBbBA","label":"vNMSv"};